export const loaderConstants = {
    LOADER: 'LOADER'
}
